import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "nonzero"
    }, [
      _createElementVNode("circle", {
        cx: "6.5",
        cy: "6.5",
        r: "6.5",
        fill: "currentcolor"
      }),
      _createElementVNode("rect", {
        width: "1",
        height: "7",
        x: "6",
        y: "3",
        fill: "#FFF",
        rx: ".5"
      }),
      _createElementVNode("rect", {
        width: "1",
        height: "7",
        x: "6",
        y: "3",
        fill: "#FFF",
        rx: ".5",
        transform: "rotate(90 6.5 6.5)"
      })
    ], -1)
  ]))]))
}
export default { render: render }